import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { finalize, first } from "rxjs/operators";
import { AuthenticationService } from "src/_services/authentication.service";

type PendingLogin = {
  userId: string;
  password: string;
  IP: string;
};

@Component({
  selector: "app-two-factor",
  templateUrl: "./two-factor.component.html",
  styleUrls: ["./two-factor.component.scss"],
})
export class TwoFactorComponent implements OnInit {
  form: FormGroup;
  loading = false;
  submitted = false;
  error = "";
  username = "";
  private pendingLogin: PendingLogin | null = null;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      otp: ["", [Validators.required, Validators.pattern(/^\d{6}$/)]],
    });

    const pending = this.authenticationService.getPending2faLogin();
    if (!pending) {
      this.router.navigateByUrl("/login");
      return;
    }

    this.pendingLogin = pending as PendingLogin;
    this.username = (this.pendingLogin && this.pendingLogin.userId) || "";
  }

  get f() {
    return this.form.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.form.invalid || !this.pendingLogin) return;

    this.loading = true;
    this.authenticationService
      .login2fa(
        this.pendingLogin.userId,
        this.pendingLogin.password,
        this.pendingLogin.IP,
        this.f.otp.value
      )
      .pipe(
        first(),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe(
        (data) => {
          this.authenticationService.clearPending2faLogin();
          this.authenticationService.openSnackBar("Login Successful.");
          this.authenticationService.navigateAfterLogin(data);
        },
        (error) => {
          this.error = error;
          const msg =
            (error && error.error && error.error.message) || "Invalid OTP";
          this.authenticationService.openErrorSnackBar(msg);
        }
      );
  }
}

